var map = {
	"./bg.json": [
		"29fa",
		"chunk-2d0b3e38"
	],
	"./de.json": [
		"6e36",
		"chunk-2d0dae88"
	],
	"./en.json": [
		"4cd1",
		"chunk-2d0cc432"
	],
	"./es.json": [
		"955e",
		"chunk-2d0e57e2"
	],
	"./es_MX.json": [
		"e353",
		"chunk-2d225082"
	],
	"./fr.json": [
		"e501",
		"chunk-2d225767"
	],
	"./hu.json": [
		"057c",
		"chunk-2d0a40c7"
	],
	"./tr.json": [
		"06d9",
		"chunk-2d0a49d1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5412";
module.exports = webpackAsyncContext;